import React, { useState, useEffect, useCallback } from 'react';
import { Button, Table, Modal, Form, Spinner, Image } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Select from 'react-select';
import FixRequiredSelect from '../../components/sis/modalcliente/FixRequiredSelect';
import { getAllProcedimiento } from '../../../api/AdminApi';
import { getAllPaciente } from '../../../api/pacienteApi';
import { getAllUsuario } from '../../../api/usuarioApi';
import { deleteAsistencia, getAllAsistencia, InsertAsistencia, updateAsistencia } from '../../../api/AsistenciaApi';
import { FaImage } from 'react-icons/fa';
import { CALL_UPLOADS } from '../../../context/constValues';
import Swal from 'sweetalert2';
import './Asistencias.css';
const Asistencias = () => {
  const [showModal, setShowModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [asistencias, setAsistencias] = useState([]);
  const [filteredAsistencias, setFilteredAsistencias] = useState([]);
  const [procedimientos, setProcedimientos] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [currentAsistencia, setCurrentAsistencia] = useState({
    idasistencia: null,
    fecha: '',
    hora: '',
    procedimiento: '',
    tipo: '',
    tarifa: '',
    honorario: '',
    asignado: '',
    paciente: '',
    foto: null
  });
  const [isEditing, setIsEditing] = useState(false);
  const [loadingStates, setLoadingStates] = useState({
    adding: false,
    editing: false,
    deleting: false,
    fetchingPhoto: false,
  });
  const [errors, setErrors] = useState({});
  const [filterData, setFilterData] = useState({
    fecha: '',
    idPaciente: null,
    idAsignado: null,
    liquidado: 'no', // <- NEW: for liquidado filtering
  });

  const setLoading = (key, value) => {
    setLoadingStates((prev) => ({ ...prev, [key]: value }));
  };

  const fetchAsistencias = useCallback(async () => {
    try {
      const response = await getAllAsistencia();
      setAsistencias(response);
      setFilteredAsistencias(response);
    } catch (error) {
      console.error('Error fetching asistencias:', error);
    }
  }, []);

  const fetchProcedimientos = useCallback(async () => {
    try {
      const response = await getAllProcedimiento();
      setProcedimientos(response);
    } catch (error) {
      console.error('Error fetching procedimientos:', error);
    }
  }, []);

  const fetchPacientes = useCallback(async () => {
    try {
      const response = await getAllPaciente();
      setPacientes(response);
    } catch (error) {
      console.error('Error fetching pacientes:', error);
    }
  }, []);

  const fetchUsuarios = useCallback(async () => {
    try {
      const response = await getAllUsuario();
      const filteredUsuarios = response.filter(user => user.estaActivo !== 'Inactivo');
      setUsuarios(filteredUsuarios);
    } catch (error) {
      console.error('Error fetching usuarios:', error);
    }
  }, []);

  const handleShowModal = () => {
    setCurrentAsistencia({
      idasistencia: null,
      fecha: '',
      hora: '',
      procedimiento: '',
      tipo: '',
      tarifa: '',
      honorario: '',
      asignado: '',
      paciente: '',
      foto: null
    });
    setIsEditing(false);
    setShowModal(true);
    fetchProcedimientos();
    fetchPacientes();
    fetchUsuarios();
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentAsistencia({
      idasistencia: null,
      fecha: '',
      hora: '',
      procedimiento: '',
      tipo: '',
      tarifa: '',
      honorario: '',
      asignado: '',
      paciente: '',
      foto: null
    });
    setErrors({});
  };

  const handleShowPhotoModal = async (foto) => {
    try {
      setLoading('fetchingPhoto', true);
      const res = await fetch(`${CALL_UPLOADS}/${foto}`);
      if (res.ok) {
        const imageBlob = await res.blob();
        const imageObjectURL = URL.createObjectURL(imageBlob);
        setSelectedPhoto(imageObjectURL);
        setShowPhotoModal(true);
      } else {
        throw new Error('No se pudo cargar la imagen existente');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading('fetchingPhoto', false);
    }
  };

  const handleClosePhotoModal = () => {
    setSelectedPhoto(null);
    setShowPhotoModal(false);
  };

  const handleSave = async () => {
    if (
      currentAsistencia.fecha.trim() === '' ||
      currentAsistencia.hora.trim() === '' ||
      currentAsistencia.procedimiento.trim() === '' ||
      currentAsistencia.tipo.trim() === '' ||
      currentAsistencia.tarifa.trim() === '' ||
      currentAsistencia.honorario.trim() === ''
    ) return;

    setLoading(isEditing ? 'editing' : 'adding', true);
    const asistenciaData = {
      idasistencia: currentAsistencia.idasistencia,
      fecha: currentAsistencia.fecha,
      hora: currentAsistencia.hora,
      procedimiento: currentAsistencia.procedimiento,
      tipo: currentAsistencia.tipo,
      tarifa: parseFloat(currentAsistencia.tarifa.replace(/\./g, '')),
      honorario: parseFloat(currentAsistencia.honorario.replace(/\./g, '')),
      asignado: currentAsistencia.asignado,
      paciente: currentAsistencia.paciente,
      foto: currentAsistencia.foto,
      oldFoto: isEditing ? asistencias.find(asis => asis.idasistencia === currentAsistencia.idasistencia)?.foto : null
    };

    try {
      if (isEditing) {
        await updateAsistencia(asistenciaData);
      } else {
        await InsertAsistencia(asistenciaData);
      }
      await fetchAsistencias();
      handleCloseModal();
    } catch (error) {
      console.error('Error al guardar asistencia:', error);
    } finally {
      setLoading(isEditing ? 'editing' : 'adding', false);
    }
  };

  const handleEdit = (asistencia) => {
    // Si está liquidado no hace nada
    if (asistencia.idliquidacion !== null && asistencia.idliquidacion !== undefined) {
      return;
    }
    setCurrentAsistencia({
      idasistencia: asistencia.idasistencia,
      fecha: asistencia.fecha,
      hora: asistencia.hora,
      procedimiento: asistencia.procedimiento,
      tipo: asistencia.tipo,
      tarifa: formatNumber(asistencia.tarifa),
      honorario: formatNumber(asistencia.honorario),
      asignado: asistencia.asignado,
      paciente: asistencia.paciente || '',
      foto: null
    });
    setIsEditing(true);
    setShowModal(true);
    fetchProcedimientos();
    fetchPacientes();
    fetchUsuarios();
  };

  const handleDelete = async (asistencia) => {
    // Si está liquidado no hace nada
    if (asistencia.idliquidacion !== null && asistencia.idliquidacion !== undefined) {
      return;
    }

    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'No podrás revertir esta acción.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });

    if (result.isConfirmed) {
      setLoading('deleting', true);
      try {
        await deleteAsistencia(asistencia.idasistencia);
        await fetchAsistencias();
        Swal.fire({
          title: 'Eliminado',
          text: 'La asistencia ha sido eliminada.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (err) {
        console.error('Error al eliminar la asistencia:', err);
        Swal.fire({
          title: 'Error',
          text: 'No se pudo eliminar la asistencia. Intente nuevamente.',
          icon: 'error',
          confirmButtonText: 'Aceptar',
        });
      } finally {
        setLoading('deleting', false);
      }
    }
  };

  const formatNumber = (value) => {
    if (!value && value !== 0) return '';
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    return num.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  const handleNumberChange = (e, field) => {
    let value = e.target.value.replace(/[^0-9]/g, '');
    if (value) {
      value = parseFloat(value).toLocaleString('es-ES', { minimumFractionDigits: 0 });
    }
    setCurrentAsistencia({ ...currentAsistencia, [field]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setCurrentAsistencia({ ...currentAsistencia, foto: file });
  };

  const handleProcedimientoChange = (selectedOption) => {
    const selectedProc = procedimientos.find(proc => proc.procedimiento === selectedOption?.value);
    setCurrentAsistencia({
      ...currentAsistencia,
      procedimiento: selectedOption ? selectedOption.value : '',
      tipo: selectedProc ? selectedProc.tipo : '',
      tarifa: selectedProc ? formatNumber(selectedProc.tarifa) : '',
      honorario: selectedProc ? formatNumber(selectedProc.honorario) : '',
    });
  };

  const handlePacienteChange = (selectedOption) => {
    setCurrentAsistencia({
      ...currentAsistencia,
      paciente: selectedOption ? selectedOption.value : ''
    });
  };

  const handleUsuarioChange = (selectedOption) => {
    setCurrentAsistencia({
      ...currentAsistencia,
      asignado: selectedOption ? selectedOption.value : ''
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePacienteFilterChange = (selectedOption) => {
    setFilterData((prev) => ({
      ...prev,
      idPaciente: selectedOption ? selectedOption.value : null,
    }));
  };

  const handleAsignadoFilterChange = (selectedOption) => {
    setFilterData((prev) => ({
      ...prev,
      idAsignado: selectedOption ? selectedOption.value : null,
    }));
  };

  // New handler for Liquidado filter
  const handleLiquidadoFilterChange = (selectedOption) => {
    setFilterData((prev) => ({
      ...prev,
      liquidado: selectedOption ? selectedOption.value : '',
    }));
  };

  const applyFilters = useCallback(() => {
    let filtered = [...asistencias];
    if (filterData.fecha) {
      filtered = filtered.filter((asis) => asis.fecha === filterData.fecha);
    }
    if (filterData.idPaciente !== null) {
      filtered = filtered.filter((asis) => asis.paciente === filterData.idPaciente);
    }
    if (filterData.idAsignado !== null) {
      filtered = filtered.filter((asis) => asis.asignado === filterData.idAsignado);
    }
    // New: Liquidado filter logic
    if (filterData.liquidado !== '') {

      if (filterData.liquidado === 'si') {
        filtered = filtered.filter((asis) => asis.idliquidacion !== null);
      } else if (filterData.liquidado === 'no') {
        filtered = filtered.filter((asis) => asis.idliquidacion === null);
      }
    }
    setFilteredAsistencias(filtered);
  }, [asistencias, filterData]);

  const procedimientoOptions = procedimientos.map(proc => ({
    value: proc.procedimiento,
    label: proc.procedimiento
  }));

  const pacienteOptions = pacientes.map(pac => ({
    value: pac.IdPacientes,
    label: `${pac.NombrePaciente}`
  }));

  const usuarioOptions = usuarios.map(user => ({
    value: user.IdUsuario,
    label: user.Usuario
  }));

  const selectedProcedimiento = procedimientoOptions.find(option => option.value === currentAsistencia.procedimiento) || null;
  const selectedPaciente = pacienteOptions.find(option => option.value === currentAsistencia.paciente) || null;
  const selectedUsuario = usuarioOptions.find(option => option.value === currentAsistencia.asignado) || null;

  // Liquidado select options
  const liquidadoOptions = [
    { value: '', label: 'Todos' },
    { value: 'si', label: 'Sí' },
    { value: 'no', label: 'No' },
  ];
  const selectedLiquidado = liquidadoOptions.find(opt => opt.value === filterData.liquidado);

  useEffect(() => {
    fetchAsistencias();
    fetchPacientes();
    fetchUsuarios();
  }, [fetchAsistencias, fetchPacientes, fetchUsuarios]);

  useEffect(() => {
    applyFilters();
  }, [filterData, asistencias, applyFilters]);

  return (
    <div className="card">
      <div className="card-header border-0 pb-0">
        <div className="d-flex gap-2 align-items-center filter-container">
          <Button
            variant="primary"
            size="sm"
            onClick={handleShowModal}
            disabled={loadingStates.adding || loadingStates.editing || loadingStates.deleting}
          >
            {loadingStates.adding ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Agregando...
              </>
            ) : (
              'Agregar Asistencia'
            )}
          </Button>
          <Form.Group className="me-2 form-group">
            <Form.Label>Filtrar por Fecha</Form.Label>
            <Form.Control
              type="date"
              name="fecha"
              value={filterData.fecha}
              onChange={handleFilterChange}
              disabled={loadingStates.adding || loadingStates.editing || loadingStates.deleting}
            />
          </Form.Group>
          <Form.Group className="me-2 form-group" style={{ minWidth: '200px' }}>
            <Form.Label>Filtrar por Usuario</Form.Label>
            <FixRequiredSelect
              SelectComponent={Select}
              options={[{ label: 'Todos', value: null }, ...pacienteOptions]}
              isSearchable
              value={pacienteOptions.find((option) => option.value === filterData.idPaciente) || { label: 'Todos', value: null }}
              onChange={handlePacienteFilterChange}
              placeholder="Seleccione un paciente"
              isLoading={pacientes.length === 0}
              loadingMessage={() => 'Cargando'}
              noOptionsMessage={() => 'Sin Datos'}
              isDisabled={loadingStates.adding || loadingStates.editing || loadingStates.deleting}
            />
          </Form.Group>
          <Form.Group className="me-2 form-group" style={{ minWidth: '200px' }}>
            <Form.Label>Filtrar por Asignado</Form.Label>
            <FixRequiredSelect
              SelectComponent={Select}
              options={[{ label: 'Todos', value: null }, ...usuarioOptions]}
              isSearchable
              value={usuarioOptions.find((option) => option.value === filterData.idAsignado) || { label: 'Todos', value: null }}
              onChange={handleAsignadoFilterChange}
              placeholder="Seleccione un usuario"
              isLoading={usuarios.length === 0}
              loadingMessage={() => 'Cargando'}
              noOptionsMessage={() => 'Sin Datos'}
              isDisabled={loadingStates.adding || loadingStates.editing || loadingStates.deleting}
            />
          </Form.Group>
          <Form.Group className="me-2 form-group" style={{ minWidth: '140px' }}>
            <Form.Label>Filtrar por Liquidado</Form.Label>
            <Select
              options={liquidadoOptions}
              value={selectedLiquidado}
              onChange={handleLiquidadoFilterChange}
              isClearable={false}
              placeholder="Todos"
              isDisabled={loadingStates.adding || loadingStates.editing || loadingStates.deleting}
            />
          </Form.Group>
        </div>
      </div>
      <div className="card-body">
        <PerfectScrollbar
          style={{ height: '370px', overflowX: 'auto' }}
          options={{ wheelPropagation: true, suppressScrollY: false, suppressScrollX: false }}
          id="DZ_W_TimeLine"
          className="widget-timeline dlab-scroll height370 ps ps--active-y"
        >
          <table className="table verticle-middle table-responsive-md">
            <thead style={{ backgroundColor: '#304a97' }}>
              <tr>
                <th style={{ width: '15%' }}><strong>Fecha Hora</strong></th>
                <th style={{ width: '15%' }}><strong>Usuario</strong></th>
                <th style={{ width: '18%' }}><strong>Procedimiento</strong></th>
                <th style={{ width: '10%' }}><strong>Tipo</strong></th>
                <th style={{ width: '10%' }}><strong>Honorario</strong></th>
                <th style={{ width: '12%' }}><strong>Asignado</strong></th>
                <th style={{ width: '8%' }}><strong>Opciones</strong></th>
                {/* Optionally show if liquidado in table: */}
                {/* <th style={{ width: '8%' }}><strong>Liquidado</strong></th> */}
              </tr>
            </thead>
            <tbody>
              {filteredAsistencias.map((asis, index) => (
                <tr key={index}>
                  <td>{asis.fecha} {asis.hora}</td>
                  <td>{asis.NombrePaciente}</td>
                  <td style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>{asis.procedimiento}</td>
                  <td style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>{asis.tipo}</td>
                  <td>{formatNumber(asis.honorario)}</td>
                  <td>{asis.Usuario}</td>
                  <td>
                    <div className="d-flex">
                      {/* Edit Icon */}
                      <li
                        className={`btn btn-primary shadow btn-xs sharp me-1${asis.idliquidacion !== null && asis.idliquidacion !== undefined ? ' disabled-icon' : ''}`}
                        onClick={() => {
                          if (asis.idliquidacion === null || asis.idliquidacion === undefined) handleEdit(asis);
                        }}
                        style={asis.idliquidacion !== null && asis.idliquidacion !== undefined ? { pointerEvents: "none" } : {}}
                        aria-disabled={asis.idliquidacion !== null && asis.idliquidacion !== undefined}
                      >
                        {loadingStates.editing && asis.idasistencia === currentAsistencia.idasistencia ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <i
                            className="fas fa-pencil-alt"
                            style={asis.idliquidacion !== null && asis.idliquidacion !== undefined ? { color: "#bdbdbd" } : {}}
                          />
                        )}
                      </li>
                      {/* Photo Icon (no gris, sólo se deshabilita si loading) */}
                      <li
                        className="btn btn-primary shadow btn-xs sharp me-1"
                        onClick={() => handleShowPhotoModal(asis.foto)}
                        disabled={loadingStates.fetchingPhoto}
                      >
                        {loadingStates.fetchingPhoto ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <FaImage />
                        )}
                      </li>
                      {/* Delete Icon */}
                      <li
                        className={`btn btn-danger shadow btn-xs sharp me-1${asis.idliquidacion !== null && asis.idliquidacion !== undefined ? ' disabled-icon' : ''}`}
                        onClick={() => {
                          if (asis.idliquidacion === null || asis.idliquidacion === undefined) handleDelete(asis);
                        }}
                        style={asis.idliquidacion !== null && asis.idliquidacion !== undefined ? { pointerEvents: "none" } : {}}
                        aria-disabled={asis.idliquidacion !== null && asis.idliquidacion !== undefined}
                      >
                        {loadingStates.deleting ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <i
                            className="fa fa-trash"
                            style={asis.idliquidacion !== null && asis.idliquidacion !== undefined ? { color: "#bdbdbd" } : {}}
                          />
                        )}
                      </li>
                    </div>
                  </td>
                  {/* Optionally show if liquidado in table: */}
                  {/* <td>{asis.IdLiquidacion !== 0 ? 'Sí' : 'No'}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </PerfectScrollbar>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Editar Asistencia' : 'Agregar Asistencia'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Fecha</Form.Label>
              <Form.Control
                type="date"
                value={currentAsistencia.fecha}
                onChange={(e) => setCurrentAsistencia({ ...currentAsistencia, fecha: e.target.value })}
                disabled={loadingStates.adding || loadingStates.editing}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Hora</Form.Label>
              <Form.Control
                type="time"
                value={currentAsistencia.hora}
                onChange={(e) => setCurrentAsistencia({ ...currentAsistencia, hora: e.target.value })}
                disabled={loadingStates.adding || loadingStates.editing}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Paciente</Form.Label>
              <Select
                options={pacienteOptions}
                value={selectedPaciente}
                onChange={handlePacienteChange}
                isDisabled={loadingStates.adding || loadingStates.editing}
                placeholder="Seleccione un paciente"
                isLoading={pacientes.length === 0}
                loadingMessage={() => "Cargando"}
                noOptionsMessage={() => "Sin Datos"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Procedimiento</Form.Label>
              <Select
                options={procedimientoOptions}
                value={selectedProcedimiento}
                onChange={handleProcedimientoChange}
                isDisabled={loadingStates.adding || loadingStates.editing}
                placeholder="Seleccione un procedimiento"
                isLoading={procedimientos.length === 0}
                loadingMessage={() => "Cargando"}
                noOptionsMessage={() => "Sin Datos"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Tipo</Form.Label>
              <Form.Control
                type="text"
                value={currentAsistencia.tipo}
                disabled
                placeholder="Seleccione un procedimiento para cargar el tipo"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Honorario</Form.Label>
              <Form.Control
                type="text"
                value={currentAsistencia.honorario}
                onChange={(e) => handleNumberChange(e, 'honorario')}
                placeholder="Ingrese el honorario"
                disabled={loadingStates.adding || loadingStates.editing}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Asignado</Form.Label>
              <Select
                options={usuarioOptions}
                value={selectedUsuario}
                onChange={handleUsuarioChange}
                isDisabled={loadingStates.adding || loadingStates.editing}
                placeholder="Seleccione un usuario"
                isLoading={usuarios.length === 0}
                loadingMessage={() => "Cargando"}
                noOptionsMessage={() => "Sin Datos"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Foto</Form.Label>
              <Form.Control
                type="file"
                onChange={handleFileChange}
                disabled={loadingStates.adding || loadingStates.editing}
                accept="image/*"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={handleCloseModal}
            disabled={loadingStates.adding || loadingStates.editing}
          >
            Cerrar
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={loadingStates.adding || loadingStates.editing}
          >
            {loadingStates.adding || loadingStates.editing ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                {isEditing ? 'Actualizando...' : 'Guardando...'}
              </>
            ) : (
              isEditing ? 'Actualizar' : 'Guardar'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPhotoModal} onHide={handleClosePhotoModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Ver Foto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {loadingStates.fetchingPhoto ? (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Cargando...</span>
            </Spinner>
          ) : selectedPhoto ? (
            <Image
              src={selectedPhoto}
              alt="Foto de asistencia"
              style={{ maxWidth: '100%', maxHeight: '400px' }}
              fluid
            />
          ) : (
            <p>No hay foto disponible.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={handleClosePhotoModal}
            disabled={loadingStates.fetchingPhoto}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Asistencias;